<template>
  	<div class="rightBlock otherTabC">
      <link href="../asserts/css/otherTab.css" rel="stylesheet" type="text/css">
      <el-container>
        <el-main>

          <p lable>{{$t("otherTab.deviceInfo")}}</p>
          <el-row info style="margin: 10px 5px 15px 0;">
            <span class="infoT">{{$t("otherTab.deviceNameInfo")}}：{{Name}}</span>
            <span class="infoT">{{$t("otherTab.deviceSNInfo")}}：{{SN}}</span>
          </el-row>

          <!-- <el-row info style="margin: 10px 5px 15px 0;">
            <span class="infoT">{{$t("otherTab.deviceTypeInfo")}}：{{softType}}</span>
            <span class="infoT">{{$t("otherTab.deviceVerInfo")}}：{{FirmwareVer}}</span>
          </el-row> -->

          <el-row info style="margin: 10px 5px 15px 0;">
            <span class="infoT">{{$t("otherTab.deviceCpu")}}：High Speed USB 2.0</span>
            <span class="infoT">{{$t("otherTab.deviceReta")}}：8K</span>
          </el-row>

          <el-row info>
            <span class="infoT">{{$t("otherTab.deviceHall")}}：{{rt}}mm</span>
            <span class="infoT">{{$t("otherTab.deviceAxis")}}：{{axis}}</span>
          </el-row>


          <p lable>{{$t("otherTab.deviceModeInfo")}}</p>
          <el-row>
            <el-select v-model="mode" @change="setDeviceMode" placeholder="windows">
              <el-option style="width: 290px;"
                v-for="item in modes"
                :key="item.mode"
                :label="item.label"
                :value="item.mode">
                <span style="float: left">{{ item.label }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.mode }}</span>
              </el-option>
            </el-select>
          </el-row>

          <!-- <p lable>{{$t("otherTab.rateInfo")}}</p>
          <el-row>
            <el-select v-model="rate" @change="setDeviceRate" placeholder="windows">
              <el-option style="width: 290px;" 
                v-for="item in rates"
                :key="item.val"
                :label="item.label"
                :value="item.val">
                <span style="float: left">{{ item.label }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.val }}</span>
              </el-option>
            </el-select>
          </el-row> -->

          <p lable>{{$t("otherTab.winInfo")}}</p>
          <el-row>
            <el-select v-model="wins" @change="setDeviceWinKey" placeholder="windows">
              <el-option style="width: 290px;"
                v-for="item in win"
                :key="item.mode"
                :label="item.label"
                :value="item.mode">
                <span style="float: left">{{ item.label }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.mode }}</span>
              </el-option>
            </el-select>
          </el-row>

          <p lable>{{$t("otherTab.siteInfo")}}</p>
          <el-row>
            <el-select v-model="site" @change="setDeviceSite" placeholder="site">
              <el-option style="width: 290px;"
                v-for="item in sites"
                :key="item.mode"
                :label="item.label"
                :value="item.label">
                <span style="float: left">{{ item.label }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.mode }}</span>
              </el-option>
            </el-select>
          </el-row>


          <p lable>{{$t("otherTab.deviceSleep")}}</p>
          <el-row>
            <el-select v-model="sleep" @change="setDeviceSleep" placeholder="2min">
              <el-option style="width: 290px;" 
                v-for="item in sleeps"
                :key="item.sleep"
                :label="item.label"
                :value="item.sleep">
                <span style="float: left">{{ item.label }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.sleep }}</span>
              </el-option>
            </el-select>
          </el-row>

          <!-- <p lable>客户端启动设置</p>
          <el-row>  
            <el-radio v-model="start" label="1">开机自动启动</el-radio>
            <el-radio v-model="start" label="0">禁用自动启动</el-radio>
          </el-row> -->
          <!-- <p lable>{{$t("otherTab.theme")}}</p>
          <el-row>
            <el-button @click="toggleTheme('light')" info>{{$t("otherTab.light")}} <i class="el-icon-sunny"></i></el-button>
            <el-button @click="toggleTheme('dark')" info>{{$t("otherTab.dark")}} <i class="el-icon-moon"></i></el-button>
          </el-row> -->

          <p lable>{{$t("otherTab.otherInfo")}}</p>
          <el-row>
            <el-button @click="restDevice" info>{{$t("otherTab.restDevice")}} <i class="el-icon-refresh"></i></el-button>
            <el-button @click="checkUpdate" info>{{$t("otherTab.checkUpdate")}} （{{FirmwareFull}}）<i class="el-icon-upload"></i></el-button>
          </el-row>

          <el-dialog :title="$t('update.localhostTitle')"
          width="50%" 
          :close-on-click-modal="false" 
          :close-on-press-escape="false"
          :visible.sync="dialogLocalhostVisible">
          <el-alert v-show="msgShow" :title="msg" type="warning" closable="false" center show-icon></el-alert>
          <child-localhostC ref="childlocalhostref"></child-localhostC>

          <div slot="footer" class="dialog-footer">
          <!-- <el-button @click="dialogLocalhostVisible = false">{{$t("update.cancelInfo")}}</el-button> -->
          <!-- <el-button type="primary" @click="saveEND">{{$t("update.saveInfo")}}</el-button> -->
          </div>
          </el-dialog>

          <el-dialog :title="$t('update.cloudTitle')"
          width="50%" 
          :close-on-click-modal="false" 
          :close-on-press-escape="false"
          :visible.sync="dialogCloudVisible">
          <el-alert v-show="msgShow" :title="msg" type="warning" closable="false" center show-icon></el-alert>
          
          <child-cloudC  :key="componentKey"  ref="childcloudc"></child-cloudC>

          <div slot="footer" class="dialog-footer">
          <!-- <el-button @click="dialogLocalhostVisible = false">{{$t("update.cancelInfo")}}</el-button> -->
          <!-- <el-button type="primary" @click="saveEND">{{$t("update.saveInfo")}}</el-button> -->
          </div>
          </el-dialog>

        </el-main>
      </el-container>
	  </div>
</template>


<script>
import cmd10 from '../../../../theme/cmd1.0.config.json';
import { ToolsHandle } from '../../../../utils/tools.js';

import localhostC from '../../../../components/update/localhost.vue'
import cloudC from '../../../../components/update/cloud.vue'

export default {
  name: 'otherTabC',
  components: 
  {
    'child-localhostC':localhostC,
    'child-cloudC':cloudC,
  },
  data() {

    return {
      ThemeConf:null,
      HIDDeviceObj:null,
      dialogLocalhostVisible:false,
      dialogCloudVisible:false,
      componentKey:0,
      Name:"-",
      softType:"-",
      SN:"-",
      FirmwareVer:"-",
      FirmwareFull:"-",
      axis:"-",
      rt:'-',

      start:1,
      mode:"win",
      modes:
      [
        {
          mode: 'win',
          label: 'Windows'
        }, 
        {
          mode: 'mac',
          label: 'Mac'
        }
      ],
      wins:0,
      win:
      [
        {
          mode: 1,
          label: this.$i18n.t("defineData.winStatus.winLock"),
          disabled: true
        }, 
        {
          mode: 0,
          label: this.$i18n.t("defineData.winStatus.winUNLock"),
          disabled: true
        }
      ],
      site:"--",
      sites:[],
      rate:"8KHz",
      rates:
      [
        {
          val: 0,
          label: '8KHz'
        }, 
        {
          val: 1,
          label: '4KHz'
        },
        {
          val: 2,
          label: '2KHz'
        },
        {
          val: 3,
          label: '1KHz'
        },
        {
          val: 4,
          label: '500Hz'
        },
        {
          val: 5,
          label: '250Hz'
        },
        {
          val: 6,
          label: '125Hz'
        },
      ],
      sleeps: [{
          sleep: 1,
          label: '1min'
        }, 
        {
          sleep: 2,
          label: '2min'
        },
        {
          sleep: 3,
          label: '3min'
        },
        {
          sleep: 5,
          label: '5min'
        },
        {
          sleep: 10,
          label: '10min'
        },
        {
          sleep: 15,
          label: '10min'
        },
        {
          sleep: 20,
          label: '20min'
        },
        {
          sleep: 25,
          label: '25min'
        },
        {
          sleep: 30,
          label: '30min'
        },
        {
          sleep: 45,
          label: '45min'
        },
        {
          sleep: 60,
          label: '60min'
        },
        {
          sleep: 0,
          label: '从不'
        }
      ],
      sleep:10,
      start:"1",
      valMode:1,
      valChild:1,
      brightness:4,
      speed:4
    }
  },
  
  mounted() 
  { 

  },
  methods: 
  {
      init()
      {
        this.FirmwareFull = this.HIDDeviceObj.FirmwareFull;
        this.FirmwareVer = this.HIDDeviceObj.FirmwareVer;
        this.SN = this.HIDDeviceObj.SN;


        console.log(this.FirmwareVer);


        this.sites = [];
        this.sites.push({mode:1,label:this.ThemeConf.platformUrl});
        this.sites.push({mode:2,label:this.ThemeConf.HomeUrl});
        this.site = this.ThemeConf.platformUrl;

        this.softType =  this.ThemeConf.VerName + " " + this.ThemeConf.VerCode + " " + this.ThemeConf.Version;

        for(let i in this.ThemeConf.DeviceList)
        {
            if(this.ThemeConf.DeviceList[i].FirmwareVer == this.FirmwareVer)
            {
              this.Name = this.ThemeConf.DeviceList[i].name + " " + this.ThemeConf.DeviceList[i].type;
              this.axis = this.ThemeConf.DeviceList[i].axis.brand + " " + this.ThemeConf.DeviceList[i].axis.name;
              this.rt = this.ThemeConf.DeviceList[i].RT;
              break;
            }
        }

      },
      //读取键盘参数数据
      async readKeyboardParameter()
      {
          this.$notify({duration:0, offset: 120,title: this.$i18n.t("msg.synData"), message: this.$i18n.t("msg.synDataInfo"),type: 'warning'});
          //读取MAC模式状态
          const winModeData = new Uint8Array(cmd10.READ_DEVICE_MAC_MODE_CMD.map(hex => parseInt(hex, 16)));
          this.HIDDeviceObj.curDeviceHandle.sendReport(0, winModeData);
          await ToolsHandle.delay(100);

          //读取灯光数据
          this.readLigth()

          await ToolsHandle.delay(300);

          //读取win键锁定状态
          const winStatusData = new Uint8Array(cmd10.READ_DEVICE_WIN_STATUS_CMD.map(hex => parseInt(hex, 16)));
          this.HIDDeviceObj.curDeviceHandle.sendReport(0, winStatusData);
          await ToolsHandle.delay(100);

          //读取回报率状态
          const reteData = new Uint8Array(cmd10.READ_DEVICE_RETE_CMD.map(hex => parseInt(hex, 16)));
          this.HIDDeviceObj.curDeviceHandle.sendReport(0, reteData);
          await ToolsHandle.delay(100);

          //读取快捷打开驱动网站
          const siteData = new Uint8Array(cmd10.READ_DEVICE_SITE_CMD.map(hex => parseInt(hex, 16)));
          this.HIDDeviceObj.curDeviceHandle.sendReport(0, siteData);
          await ToolsHandle.delay(100);


          this.$notify.closeAll();

          this.site = this.HIDDeviceObj.curWebSite;
          this.mode = this.HIDDeviceObj.macStatus == 1?'mac':'win';
          this.wins = this.HIDDeviceObj.winKeyStatus;
          for(let i in this.rates)
          {
             if(this.rates[i].val == this.HIDDeviceObj.reteVal)
             {
               this.rate = this.rates[i].label;
               break;
             }
          }

      },
      //读取灯光数据
      async readLigth()
      {
        cmd10.SET_DEVICE_PRGB_CMD[4] = "0x00";
        //写入硬件
        const outputReportData = new Uint8Array(cmd10.SET_DEVICE_PRGB_CMD.map(hex => parseInt(hex, 16)));
        this.HIDDeviceObj.curDeviceHandle.sendReport(0, outputReportData);

        await ToolsHandle.delay(50);

        this.valMode = parseInt(this.HIDDeviceObj.modeLigth,16);
        this.brightness = parseInt(this.HIDDeviceObj.brightnessLigth,16);
        this.speed = parseInt(this.HIDDeviceObj.speedLigth,16);
        this.sleep = parseInt(this.HIDDeviceObj.sleep,16);

      },
      setDeviceSleep(item)
      {
          cmd10.SET_DEVICE_PRGB_CMD[4] = "0x01";
          cmd10.SET_DEVICE_PRGB_CMD[41] = this.valChild.toString(16);
          cmd10.SET_DEVICE_PRGB_CMD[42] = this.brightness.toString(16);
          cmd10.SET_DEVICE_PRGB_CMD[43] = this.valMode.toString(16);
          cmd10.SET_DEVICE_PRGB_CMD[44] = this.speed.toString(16);
          cmd10.SET_DEVICE_PRGB_CMD[45] = item.toString(16);
          //写入硬件
          const outputReportData = new Uint8Array(cmd10.SET_DEVICE_PRGB_CMD.map(hex => parseInt(hex, 16)));
          this.HIDDeviceObj.curDeviceHandle.sendReport(0, outputReportData);

          this.$message({message:this.$i18n.t("msg.modySuccess"),type: 'success',center: true,offset:500,duration:1000});
      },
      setDeviceRate(item)
      {

        this.$confirm(this.$i18n.t("msg.confirmInfoRate"), this.$i18n.t("msg.confirmTitRest"), 
        {
          confirmButtonText: this.$i18n.t("msg.confirmOKRest"),
          cancelButtonText: this.$i18n.t("msg.confirmNoRest"),
          type: 'warning'
        }).then(() => 
        {

          cmd10.SET_DEVICE_RETE_CMD[5] = item;
          //写入硬件结束
          const outputReportData = new Uint8Array(cmd10.SET_DEVICE_RETE_CMD.map(hex => parseInt(hex, 16)));
          this.HIDDeviceObj.curDeviceHandle.sendReport(0, outputReportData);
          this.$message({message:this.$i18n.t("msg.modySuccess"),type: 'success',center: true,offset:500,duration:1000});


        }).catch(() => {});


      },
      setDeviceWinKey(item)
      {
        cmd10.SET_DEVICE_WIN_STATUS_CMD[5] = item;
        //写入硬件结束
        const outputReportData = new Uint8Array(cmd10.SET_DEVICE_WIN_STATUS_CMD.map(hex => parseInt(hex, 16)));
        this.HIDDeviceObj.curDeviceHandle.sendReport(0, outputReportData);

        this.$message({message:this.$i18n.t("msg.modySuccess"),type: 'warning',center: true,offset:500,duration:1000});
        
      },
      async setDeviceSite(item)
      {
          var arg = ToolsHandle.stringToASCII(item);
          var siteCmd = cmd10.SET_DEVICE_SITE_CMD;

              siteCmd = siteCmd.concat(arg);
              siteCmd = siteCmd.concat(["0xFF","0xFF"]);

              siteCmd[1] = parseInt(siteCmd[1],16) + arg.length;
              siteCmd[1] = siteCmd[1].toString(16);
              siteCmd[3] = this.HIDDeviceObj.getCRC(siteCmd[1],siteCmd[2],"0xff");
              siteCmd[3] = siteCmd[3].toString(16);

          //写入硬件结束
          const outputReportData = new Uint8Array(siteCmd.map(hex => parseInt(hex, 16)));
          this.HIDDeviceObj.curDeviceHandle.sendReport(0, outputReportData);
          await ToolsHandle.delay(100);
          
          this.$message({message:this.$i18n.t("msg.modySuccess"),type: 'success',center: true,offset:500,duration:1000});
      },
      setDeviceMode(item)
      {
          if(item == "win")
          {
              //写入硬件结束
              const outputReportData = new Uint8Array(cmd10.SET_DEVICE_WIN_MODE_CMD.map(hex => parseInt(hex, 16)));
              this.HIDDeviceObj.curDeviceHandle.sendReport(0, outputReportData);

              this.$message({message:this.$i18n.t("msg.modySuccess"),type: 'success',center: true,offset:500,duration:1000});
          }
          else
          {
              //写入硬件结束
              const outputReportData = new Uint8Array(cmd10.SET_DEVICE_MAC_MODE_CMD.map(hex => parseInt(hex, 16)));
              this.HIDDeviceObj.curDeviceHandle.sendReport(0, outputReportData);

              this.$message({message:this.$i18n.t("msg.modySuccess"),type: 'success',center: true,offset:500,duration:1000});

          }
      },
      restDevice()
      {
        this.$confirm(this.$i18n.t("msg.confirmInfoRest"), this.$i18n.t("msg.confirmTitRest"), 
        {
          confirmButtonText: this.$i18n.t("msg.confirmOKRest"),
          cancelButtonText: this.$i18n.t("msg.confirmNoRest"),
          type: 'warning'
        }).then(() => 
        {

          localStorage.setItem("restDeviceTag",1);
          //写入硬件结束
          const outputReportData = new Uint8Array(cmd10.SET_DEVICE_REST_CMD.map(hex => parseInt(hex, 16)));
          this.HIDDeviceObj.curDeviceHandle.sendReport(0, outputReportData);

          this.$message({message:this.$i18n.t("msg.restSuccess"),type: 'success',center: true,offset:500,duration:1000});

          setTimeout(()=>
          {

            window.location.reload();

          },1000);

        }).catch(() => {});

      },
      async checkUpdate()
      {
          this.componentKey += 1;
          this.dialogCloudVisible = true;

          setTimeout(()=>
          {
            const ChildCloudC = this.$refs.childcloudc;
                  ChildCloudC.ThemeConf = this.ThemeConf;
                  ChildCloudC.init(this.HIDDeviceObj);
          },100);

      },
      toggleTheme(name)
      {
        this.$confirm(this.$i18n.t("msg.confirmInfoTheme"), this.$i18n.t("msg.confirmTitTheme"), 
        {
          confirmButtonText: this.$i18n.t("msg.confirmOKTheme"),
          cancelButtonText: this.$i18n.t("msg.confirmNoTheme"),
          type: 'warning'
        }).then(() => 
        {

          localStorage.setItem('theme',name + "-theme");
          window.location.reload();

        }).catch(() => {});

      }
  }
}

</script>